<template>
    <v-dialog v-model="model" max-width="600px" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card>
            <div class="pl-4 pr-3 py-3 primary">
                <div class="d-flex align-center justify-space-between">
                    <div>
                        <v-layout align-center>
                            <v-icon size="12px" color="white" class="mr-2">fa-pen fa-fw</v-icon> 
                            <div class="white--text font-weight-medium caption">MY TOP 3 UNIVERSITIES</div> 
                        </v-layout>
                    </div>
                    <div>
                        <v-btn small text fab @click="$emit('cancel')" class="my-0">
                            <v-icon small color="white">fa-times</v-icon> 
                        </v-btn>
                    </div>
                </div>
            </div>

            <v-divider></v-divider>

            <v-card-text class="pt-8">
                <div class="px-3 black--text body-1 text-center">
                    <div class="font-weight-medium">{{item.name}}</div>
                    <div class="body-2 grey--text text--darken-1">Pin it in the position you prefer:</div>
                    <div class="d-flex justify-space-between align-center mt-8">
                        <div class="d-flex align-center">
                            <v-avatar class="primary white--text font-weight-medium mr-2 text-center" size="26">
                                <span>1</span>
                            </v-avatar>
                            <div v-if="mytop.universities.p1 && mytop.universities.p1!=''">{{mytop.universities.p1.name}}</div>
                            <div class="grey--text" v-else>Empty</div>
                        </div>
                        <div>
                            <v-btn depressed small class="accent" @click="pin(1)" :disabled="sending">Pin it</v-btn>
                        </div>
                    </div>
                    <v-divider class="mt-4"></v-divider>
                    <div class="d-flex justify-space-between align-center mt-6">
                        <div class="d-flex align-center">
                            <v-avatar class="primary white--text font-weight-medium mr-2 text-center" size="26">
                                <span>2</span>
                            </v-avatar>
                            <div v-if="mytop.universities.p2 && mytop.universities.p2!=''">{{mytop.universities.p2.name}}</div>
                            <div class="grey--text" v-else>Empty</div>
                        </div>
                        <div>
                            <v-btn depressed small class="accent" @click="pin(2)" :disabled="sending">Pin it</v-btn>
                        </div>
                    </div>
                    <v-divider class="mt-4"></v-divider>
                    <div class="d-flex justify-space-between align-center mt-6">
                        <div class="d-flex align-center">
                            <v-avatar class="primary white--text font-weight-medium mr-2 text-center" size="26">
                                <span>3</span>
                            </v-avatar>
                            <div v-if="mytop.universities.p3 && mytop.universities.p3!=''">{{mytop.universities.p3.name}}</div>
                            <div class="grey--text" v-else>Empty</div>
                        </div>
                        <div>
                            <v-btn depressed small class="accent" @click="pin(3)" :disabled="sending">Pin it</v-btn>
                        </div>
                    </div>
                </div>
            </v-card-text>

            <div class="d-flex justify-end align-center px-4 pb-4" :class="(sending) ? 'pa-1' : 'pa-4'">
                <v-btn text large class="info--text text--darken-1" @click="$emit('cancel')" v-if="!sending">Cancel</v-btn>
                <!-- <v-btn text large class="accent" @click="validate" v-if="!sending">Save</v-btn> -->
                <SendingLoader v-if="sending" />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import _ from 'lodash'
import Personal from '@/firebase/personal'

export default {
    data: () => ({
        sending: false,
        mytop: {
            universities: {
                p1: '',
                p2: '',
                p3: ''
            }
        }
    }),
    props: ['model', 'item'],   
    watch: {
        model(val) {
            if (val == false) {
                this.sending = false;
            }
            this.init();
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            if (this.user.mytop) {
                this.mytop = _.merge(this.mytop, this.user.mytop);
            }
        },
        pin(num) {
            if (this.mytop.universities.p1!='' && this.mytop.universities.p1.id==this.item.id) this.mytop.universities.p1 = '';
            if (this.mytop.universities.p2!='' && this.mytop.universities.p2.id==this.item.id) this.mytop.universities.p2 = '';
            if (this.mytop.universities.p3!='' && this.mytop.universities.p3.id==this.item.id) this.mytop.universities.p3 = '';

            this.mytop.universities['p'+num] = {
                id: this.item.id,
                name: this.item.name
            };

            this.prepare();
            this.save();
        },
        prepare() {
            if (this.validateIsEmpty(this.mytop.universities.p1)) delete this.mytop.universities.p1;
            if (this.validateIsEmpty(this.mytop.universities.p2)) delete this.mytop.universities.p2;
            if (this.validateIsEmpty(this.mytop.universities.p3)) delete this.mytop.universities.p3;
        },
        save() {
            this.sending = true;

            Personal.updateMytop(this.user.uid, this.mytop)
                    .then(response => {
                        if (response === true) {
                            this.$emit('changed', this.mytop);
                            this.$store.dispatch('setSnack', {kind:'success', text:'My Top 3 has been updated.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                        this.sending = false;
                    });
        }
    }
}
</script>

